import FlooringOverviewSubPage from "./flooring-owerview-sub-page";

const SubPage = {
  OverView: FlooringOverviewSubPage,
};

export default SubPage;
